export const IMAGES = {
  shattered: "https://images.unsplash.com/photo-1733590634512-66186b83ad07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxzaGF0dGVyZWQlMjBnbGFzcyUyMHRleHR1cmUlMjBkYXJrJTIwbW9vZHl8ZW58MHx8fHwxNzkwNjk4MzgxfDA&ixlib=rb-4.1.0&q=85",
  cracked: "https://images.unsplash.com/photo-1763862730162-d8e5d3c4c890?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxzaGF0dGVyZWQlMjBnbGFzcyUyMHRleHR1cmUlMjBkYXJrJTIwbW9vZHl8ZW58MHx8fHwxNzkwNjk4MzgxfDA&ixlib=rb-4.1.0&q=85",
  portrait1: "https://images.unsplash.com/photo-1715313210517-2dcc505740f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxtYW9yaSUyMGZhbWlseSUyMGhvcGVmdWwlMjBwb3J0cmFpdCUyMG91dGRvb3JzJTIwbmV3JTIwemVhbGFuZHxlbnwwfHx8fDE3OTA2OTgzNzN8MA&ixlib=rb-4.1.0&q=85",
  portrait2: "https://images.unsplash.com/photo-1605733150368-c2b342e5681c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxtYW9yaSUyMGZhbWlseSUyMGhvcGVmdWwlMjBwb3J0cmFpdCUyMG91dGRvb3JzJTIwbmV3JTIwemVhbGFuZHxlbnwwfHx8fDE3OTA2OTgzNzN8MA&ixlib=rb-4.1.0&q=85",
  whanau: "https://images.unsplash.com/photo-1583843004789-4acbd1b3f9d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxtYW9yaSUyMGZhbWlseSUyMGhvcGVmdWwlMjBwb3J0cmFpdCUyMG91dGRvb3JzJTIwbmV3JTIwemVhbGFuZHxlbnwwfHx8fDE3OTA2OTgzNzN8MA&ixlib=rb-4.1.0&q=85",
  brain: "https://images.unsplash.com/photo-1781817957462-1b81e123c0c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxicmFpbiUyMG5ldXJvbiUyMGRhcmslMjBnbG93JTIwbWVkaWNhbCUyMHJlc2VhcmNofGVufDB8fHx8MTc5MDY5ODM4MXww&ixlib=rb-4.1.0&q=85",
};

export const REGIONS = ["Northland", "Auckland", "Waikato", "Bay of Plenty", "Tairāwhiti", "Hawke's Bay", "Taranaki", "Manawatū-Whanganui", "Wellington", "Canterbury", "Otago", "Southland", "Other / overseas"];

export const VALUES = [
  ["Manaakitanga", "People experiencing addiction deserve dignity."],
  ["Whānau", "Addiction affects families, not just individuals."],
  ["Prevention", "Act before a crisis occurs."],
  ["Early Intervention", "The earlier someone gets support, the better."],
  ["Courage", "Have the conversations people sometimes avoid."],
  ["Hope", "Recovery is possible."],
  ["Lived Experience", "People who have experienced addiction and recovery should help shape the response."],
  ["Accountability", "Be honest about the damage methamphetamine can cause."],
  ["Safety", "Protect children, whānau, volunteers, participants and storytellers."],
];

export const PILLARS = [
  ["01", "Prevent", "Stop people starting."],
  ["02", "Educate", "Give people accurate information about methamphetamine and its consequences."],
  ["03", "Intervene", "Encourage people and whānau to seek support before crisis."],
  ["04", "Support", "Connect affected people and whānau with existing professional and community services."],
  ["05", "Recover", "Show that addiction doesn't have to be the end of someone's story."],
];

export const ASKS = [
  "More accessible early intervention",
  "Better information for young people and parents",
  "Greater support for whānau affected by methamphetamine",
  "Stronger pathways into treatment and recovery",
  "Greater recognition of lived experience",
  "More community education about methamphetamine harm",
  "Better coordination between community, health and social services",
  "Continued investment in prevention rather than waiting for crisis",
  "Greater support for people maintaining recovery",
  "A stronger Christchurch/Canterbury community response",
];

export const OBJECTIVES = [
  "Establish the campaign as a credible Christchurch community initiative",
  "Deliver community education and awareness activities",
  "Establish partnerships with relevant community and support organisations",
  "Recruit lived-experience contributors and ambassadors",
  "Provide accessible information for whānau",
  "Connect people seeking help with appropriate existing services",
  "Deliver community hui and prevention events",
  "Measure campaign reach, participation and referral activity",
  "Produce a Year One Impact Report",
  "Develop a sustainable model for expansion",
];

export const BUDGET = [
  ["Campaign development", "$2,000"],
  ["Website / digital infrastructure", "$2,000"],
  ["Design, printing & educational resources", "$3,500"],
  ["Community hui and events", "$4,000"],
  ["Lived-experience participation", "$3,000"],
  ["Community facilitation / outreach", "$5,000"],
  ["Youth prevention resources", "$2,000"],
  ["Transport / outreach", "$1,500"],
  ["Evaluation", "$1,500"],
  ["Insurance, safeguarding & administration", "$2,000"],
  ["Contingency", "$1,500"],
];

export const FUNDERS = [
  ["Christchurch City Council", "Strengthening Communities Fund, Discretionary Response Fund, Youth Development Fund.", "2026 round closed — targeting next round"],
  ["COGS", "Supports community projects, hui, training, planning and facilitator costs; prioritises families, youth, Māori and Pacific communities.", "Next application cycle"],
  ["Lottery Community", "Medium-term target. Canterbury/Kaikōura grants for established organisations.", "Requires governance in place"],
  ["Philanthropic trusts", "Approached once governance, a bank account, community partnerships and evidence of demand are established.", "Later-stage target"],
];

export const TEAM = [
  ["Leadership", "Founder / Campaign Director", "Overall leadership."],
  ["Voice", "Lived Experience Lead", "Recovery and lived-experience voice."],
  ["Voice", "Whānau Lead", "Family and community perspective."],
  ["Growth", "Community Partnerships Lead", "Builds relationships."],
  ["Prevention", "Youth Lead", "Youth prevention."],
  ["Safety", "Health / Clinical Advisor", "Ensures information is safe and evidence-based."],
  ["Governance", "Governance / Finance Advisor", "Keeps the organisation funder-ready."],
  ["Voice", "Communications Lead", "Social media, website and media."],
];

export const TIMELINE = [
  ["11:00", "Welcome", "Karakia / opening appropriate to the host."],
  ["11:15", "Campaign launch", "Founder explains why this campaign exists."],
  ["11:30", "Lived experience", "Two or three carefully selected speakers who have experienced addiction and recovery."],
  ["12:00", "Whānau voices", "Family members discuss the impact and the support families need."],
  ["12:30", "Community lunch", ""],
  ["13:00", "Break the Cycle panel", "Lived-experience representative, addiction professional, community worker, whānau representative, youth representative."],
  ["14:00", "Community workshop", "“What does Christchurch need to do differently?”"],
  ["15:00", "Recovery and hope", "Recovery stories."],
  ["15:30", "Petition launch", "Officially launching “No To Meth — Save Lives and Break the Cycle.”"],
  ["16:00", "Campaign commitment", "Everyone invited to sign the commitment."],
  ["16:30", "Closing", ""],
];

export const TIERS = [
  ["Community Friend", "$500", ["Social-media acknowledgement", "Supporter certificate", "Logo on supporter webpage", "Invitation to launch event"]],
  ["Community Partner", "$2,500", ["Everything above, plus:", "Logo on selected campaign materials", "Acknowledgement at events", "Social-media thank-you campaign", "Invitation to community hui"]],
  ["Life Saver Partner", "$5,000", ["Everything above, plus:", "Prominent campaign recognition", "Event banner placement", "Partner profile", "Named in annual impact report"]],
  ["Founding Partner", "$10,000+", ["Everything above, plus:", "Founding-partner recognition", "Major event recognition", "Website prominence", "Strategic partner hui"]],
];

export const WARNING_SIGNS = [
  ["Behavioural", "Disappearing for days, sleeping at strange hours or not at all, sudden secrecy, new chaotic circles, abandoned commitments and hobbies."],
  ["Whānau impact", "Kids walking on eggshells, partners covering or making excuses, celebrations derailed, a home that feels like it's holding its breath."],
  ["Financial", "Money that never adds up, borrowing with urgent stories, unpaid bills despite income, possessions quietly sold."],
  ["Physical", "Noticeable weight change, days of poor sleep, low mood after use, looking run-down for weeks at a time."],
];

export const SUPPORT_CATEGORIES = [
  {
    title: "Meth & drug support",
    lines: [
      ["0800 METH HELP — 0800 787 797", "Alcohol & Drug Helpline · free, confidential, 24/7", "tel:0800787797"],
      ["Māori Helpline — 0800 787 798", "Kaupapa Māori alcohol & drug support · free, 24/7", "tel:0800787798"],
      ["Pasifika Helpline — 0800 787 799", "Pacific alcohol & drug support · free, 24/7", "tel:0800787799"],
      ["Youth Helpline — 0800 787 984", "Alcohol & drug support for rangatahi · free, 24/7", "tel:0800787984"],
    ],
  },
  {
    title: "Someone to talk to",
    lines: [
      ["Call or text 1737", "Need to talk? 24/7, trained counsellors", "tel:1737"],
      ["Text 8681", "Free support by text, anytime", "sms:8681"],
      ["Youthline 0800 376 633", "For rangatahi and young people", "tel:0800376633"],
      ["0800 920 092", "Canterbury mental health crisis line", "tel:0800920092"],
    ],
  },
  {
    title: "Urgent help",
    lines: [
      ["Are You OK — 0800 456 450", "Whānau violence support", "tel:0800456450"],
      ["111", "Emergency — immediate danger", "tel:111"],
    ],
  },
];

export const MASTER_MESSAGE = "Christchurch communities are strongest when no one faces meth harm alone.";

export const EMAIL = "whanaufirst@kiaora-breakthecycle.com";
export const INSTAGRAM = "@movementbreakthecycle";
export const INSTAGRAM_URL = "https://instagram.com/movementbreakthecycle";
export const THREADS = "@movementbreakthecycle";
export const THREADS_URL = "https://threads.net/@movementbreakthecycle";
export const FACEBOOK = "@NoToMethNZ";
export const PAYPAL_DONATION_URL = "https://www.paypal.com/ncp/payment/VN63N5F7AFH4Q";
